var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 8.017,
    y: 12.292,
    style: {
      fill: "#E6EAEA"
    },
    width: 495.967,
    height: 487.415
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.017,
    y: 12.292,
    style: {
      fill: "#CDD4D5"
    },
    width: 247.983,
    height: 487.415
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.017,
    y: 12.292,
    style: {
      fill: "#9AAAAA"
    },
    width: 495.967,
    height: 102.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.017,
    y: 12.292,
    style: {
      fill: "#677F82"
    },
    width: 247.983,
    height: 102.614
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M427.023,54.514H332.96c-4.427,0-8.017-3.589-8.017-8.017s3.589-8.017,8.017-8.017h94.063 c4.427,0,8.017,3.589,8.017,8.017S431.45,54.514,427.023,54.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M469.779,54.514h-17.102c-4.427,0-8.017-3.589-8.017-8.017s3.589-8.017,8.017-8.017h17.102 c4.427,0,8.017,3.589,8.017,8.017S474.206,54.514,469.779,54.514z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M435.574,199.883H72.15c-4.427,0-8.017-3.589-8.017-8.017s3.589-8.017,8.017-8.017h363.424 c4.427,0,8.017,3.589,8.017,8.017S440.001,199.883,435.574,199.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M435.574,336.701H72.15c-4.427,0-8.017-3.589-8.017-8.017c0-4.427,3.589-8.017,8.017-8.017h363.424 c4.427,0,8.017,3.589,8.017,8.017C443.591,333.112,440.001,336.701,435.574,336.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M151.155,473.52H72.15c-4.427,0-8.017-3.589-8.017-8.017s3.589-8.017,8.017-8.017h79.005 c4.427,0,8.017,3.589,8.017,8.017S155.583,473.52,151.155,473.52z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4ACFD9"
    },
    cx: 264.551,
    cy: 63.599,
    r: 25.653
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF8C29"
    },
    cx: 170.489,
    cy: 63.599,
    r: 25.653
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0353D"
    },
    cx: 76.426,
    cy: 63.599,
    r: 25.653
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD6A33"
    },
    points: "165.998,359.688 144.835,465.503 250.65,444.34 414.32,280.67 329.668,196.018  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.468,
    y: 148.257,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 833.7977 70.8582)",
    style: {
      fill: "#FD6A33"
    },
    width: 85.511,
    height: 119.715
  })), /*#__PURE__*/React.createElement("rect", {
    x: 342.366,
    y: 165.352,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 539.4852 639.6766)",
    style: {
      fill: "#CDD4D5"
    },
    width: 119.715,
    height: 85.511
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFBA7E"
    },
    points: "144.835,465.503 165.998,359.688 250.65,444.34 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#687F82"
    },
    points: "144.835,465.503 153.905,420.154 190.184,456.434 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.785,
    y: 204.441,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 268.9422 751.7472)",
    style: {
      fill: "#4ACFD9"
    },
    width: 42.755,
    height: 231.467
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.303,202.021c-2.051,0-4.103-0.782-5.668-2.348c-3.131-3.131-3.131-8.207,0-11.337l19.24-19.24 c3.131-3.131,8.207-3.131,11.337,0c3.131,3.131,3.131,8.207,0,11.337l-19.24,19.24C373.406,201.238,371.354,202.021,369.303,202.021 z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.983,4.276H256H8.017C3.589,4.276,0,7.865,0,12.292v102.614v384.802c0,4.427,3.589,8.017,8.017,8.017H256h247.983 c4.427,0,8.017-3.589,8.017-8.017V114.906V12.292C512,7.865,508.411,4.276,503.983,4.276z M256,20.309h239.967v86.58H256H16.033 v-86.58H256z M256,491.691H16.033V122.923H256h239.967v368.768H256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.303,95.336c0.009,0.003,0.016,0.007,0.025,0.011c3.611,1.276,7.387,1.924,11.222,1.924 c18.566,0,33.67-15.105,33.67-33.67s-15.103-33.671-33.669-33.671c-3.835,0-7.612,0.647-11.222,1.924 c-0.009,0.003-0.016,0.007-0.025,0.01c-13.413,4.754-22.423,17.504-22.423,31.737S239.892,90.581,253.303,95.336z M258.669,46.97 c0.001,0,0.002,0,0.003-0.001c1.891-0.669,3.869-1.007,5.88-1.007c9.725,0,17.637,7.912,17.637,17.637s-7.913,17.637-17.638,17.637 c-2.011,0-3.988-0.339-5.88-1.007c-0.001,0-0.002-0.001-0.003-0.001c-7.03-2.488-11.754-9.17-11.754-16.629 S251.638,49.459,258.669,46.97z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.489,97.269c18.566,0,33.67-15.105,33.67-33.67s-15.105-33.67-33.67-33.67s-33.67,15.105-33.67,33.67 S151.923,97.269,170.489,97.269z M170.489,45.962c9.725,0,17.637,7.912,17.637,17.637s-7.912,17.637-17.637,17.637 c-9.725,0-17.637-7.912-17.637-17.637S160.764,45.962,170.489,45.962z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.426,97.269c18.566,0,33.67-15.105,33.67-33.67s-15.105-33.67-33.67-33.67s-33.67,15.105-33.67,33.67 S57.86,97.269,76.426,97.269z M76.426,45.962c9.725,0,17.637,7.912,17.637,17.637s-7.912,17.637-17.637,17.637 s-17.637-7.912-17.637-17.637S66.701,45.962,76.426,45.962z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.803,129.883c-3.131-3.131-8.207-3.131-11.338,0l-56.314,56.315c-0.733,0.733-1.288,1.577-1.678,2.473 c-0.897,0.39-1.74,0.945-2.473,1.678l-73.668,73.668l-58.999,58.999l-30.964,30.963c-0.009,0.009-0.017,0.017-0.027,0.027 l-0.014,0.014c-0.025,0.025-0.045,0.051-0.069,0.077c-0.159,0.164-0.314,0.332-0.461,0.51c-0.055,0.065-0.1,0.135-0.153,0.202 c-0.108,0.14-0.216,0.28-0.315,0.429c-0.065,0.097-0.122,0.199-0.183,0.299c-0.074,0.122-0.151,0.243-0.218,0.37 c-0.068,0.128-0.127,0.26-0.188,0.39c-0.049,0.105-0.102,0.207-0.146,0.315c-0.067,0.162-0.124,0.329-0.181,0.495 c-0.028,0.082-0.06,0.161-0.086,0.245c-0.064,0.212-0.117,0.426-0.162,0.642c-0.009,0.042-0.022,0.081-0.031,0.123l-0.005,0.025 c-0.002,0.01-0.004,0.019-0.005,0.029l-21.137,105.689c-0.06,0.283-0.103,0.572-0.131,0.864c-0.009,0.087-0.009,0.172-0.014,0.259 c-0.011,0.174-0.025,0.347-0.024,0.524c0,0.176,0.013,0.35,0.024,0.524c0.005,0.087,0.005,0.172,0.014,0.259 c0.04,0.405,0.117,0.802,0.216,1.191c0.029,0.112,0.053,0.227,0.087,0.337c0.03,0.098,0.066,0.195,0.1,0.292 c0.049,0.144,0.098,0.288,0.156,0.428c0.031,0.076,0.067,0.151,0.1,0.227c0.069,0.156,0.141,0.31,0.219,0.461 c0.034,0.065,0.072,0.129,0.108,0.195c0.086,0.153,0.175,0.304,0.27,0.451c0.041,0.063,0.082,0.124,0.125,0.185 c0.097,0.141,0.198,0.278,0.304,0.412c0.05,0.064,0.1,0.128,0.154,0.19c0.103,0.122,0.21,0.239,0.319,0.355 c0.063,0.067,0.125,0.135,0.191,0.2c0.104,0.103,0.213,0.199,0.322,0.295c0.077,0.068,0.152,0.139,0.231,0.204 c0.109,0.09,0.224,0.172,0.339,0.255c0.162,0.12,0.328,0.232,0.5,0.339c0.111,0.069,0.22,0.14,0.333,0.204 c0.099,0.056,0.202,0.104,0.304,0.155c0.123,0.062,0.245,0.123,0.37,0.178c0.093,0.042,0.189,0.078,0.284,0.115 c0.148,0.059,0.297,0.113,0.449,0.164c0.081,0.027,0.161,0.052,0.244,0.076c0.184,0.055,0.371,0.1,0.559,0.141 c0.042,0.009,0.081,0.022,0.123,0.031c0.018,0.003,0.036,0.004,0.056,0.009c0.218,0.042,0.438,0.075,0.661,0.098 c0.031,0.003,0.063,0.01,0.094,0.012c0.249,0.024,0.5,0.039,0.754,0.039c0.003,0,0.005,0,0.009,0c0.003,0,0.005,0,0.009,0 c0.253,0,0.505-0.014,0.754-0.039c0.032-0.003,0.064-0.01,0.096-0.013c0.222-0.024,0.441-0.057,0.66-0.098 c0.018-0.003,0.036-0.004,0.056-0.009l45.302-9.06c0.005-0.001,0.01-0.002,0.015-0.003l0.032-0.006l60.415-12.083 c0.007-0.001,0.015-0.003,0.024-0.004l0.028-0.005c0.047-0.01,0.091-0.025,0.138-0.035c0.21-0.046,0.419-0.096,0.625-0.158 c0.088-0.027,0.171-0.061,0.258-0.09c0.161-0.056,0.324-0.11,0.482-0.175c0.112-0.047,0.219-0.102,0.328-0.153 c0.126-0.059,0.253-0.115,0.377-0.182c0.13-0.069,0.253-0.147,0.378-0.223c0.097-0.059,0.197-0.114,0.291-0.177 c0.149-0.099,0.29-0.208,0.431-0.316c0.066-0.051,0.136-0.097,0.201-0.152c0.175-0.144,0.341-0.297,0.503-0.455 c0.027-0.027,0.057-0.048,0.082-0.075l0.016-0.016c0.009-0.009,0.017-0.016,0.025-0.025l5.309-5.309l110.306-110.306l48.015-48.015 l60.465-60.465c3.131-3.131,3.131-8.207,0-11.338L395.803,129.883z M360.637,323.016L250.65,433.002l-15.873-15.872l26.891-26.891 l55.886-55.886l69.556-69.556l15.872,15.872L360.637,323.016z M158.828,436.414l15.095,15.095l-18.869,3.774L158.828,436.414z  M192.819,447.731l-30.211-30.211l8.314-41.57l16.618,16.618l30.233,30.233l16.618,16.617L192.819,447.731z M306.218,323.016 l-55.886,55.886l-26.891,26.891l-18.896-18.896l152.333-152.333l18.896,18.896L306.218,323.016z M193.208,375.56l-15.873-15.873 l25.335-25.335l58.999-58.999l68-68l15.872,15.873L193.208,375.56z M414.32,269.332l-21.54-21.54l-30.234-30.233l-21.54-21.541 l49.128-49.128l73.314,73.314L414.32,269.332z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.3114fdcc.svg";
export { ForwardRef as ReactComponent };